var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group case-conclusion"},[_c('label',{attrs:{"for":"case-conclusion"}},[_vm._v(_vm._s(_vm.$t('conclusion')))]),_c('pre',[_vm._v(_vm._s(_vm.conclusion(_vm.value)))])])}
var staticRenderFns = []

export { render, staticRenderFns }